var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.ftpDialog,
          expression: "ftpDialog"
        }
      ],
      staticClass: "popup"
    },
    [
      _c(
        "div",
        {
          ref: "ftpDiv",
          staticClass: "content",
          class: _vm.addFtp,
          attrs: { id: "addFtp" }
        },
        [
          _c("div", { staticClass: "title" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("language.popup.addCloudPopup.addFtp")))
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "icon white-close dialog-close",
              on: {
                click: function($event) {
                  _vm.ftpDialog = false
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "add-ftp-cont" },
            [
              _c("div", { staticClass: "add-cloud-cont-top" }, [
                _c("div", { staticClass: "add-cloud-drive-position" }, [
                  _c("div", { staticClass: "cloud FTP add-cloud-size" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "add-cloud-text" }, [
                    _c("b", [
                      _vm._v(
                        _vm._s(_vm.$t("language.popup.addCloudPopup.addFtp"))
                      )
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "add-ftp-cont-body" }, [
                _c("div", { staticStyle: { "margin-bottom": "5px" } }, [
                  _c("span", { staticClass: "add-ftp-des" }, [
                    _vm._v(
                      _vm._s(_vm.$t("language.popup.addCloudPopup.addFtpDes"))
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "ftp-input-line" },
                  [
                    _c("font", { staticClass: "cloud-cont-name" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("language.popup.addCloudPopup.displayName")
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticStyle: { float: "right" } },
                      [
                        _c("cloud-select", {
                          ref: "cloudSelect",
                          staticStyle: { "min-width": "180px" },
                          attrs: {
                            selectOption: _vm.selectOption,
                            placeholder: _vm.selectValue
                          },
                          on: { changeOption: _vm.onChangeOption }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.displayName,
                          expression: "displayName"
                        }
                      ],
                      staticClass: "ftp-cont-input",
                      style: {
                        width: this.$i18n.locale == "italian" ? "260Px" : ""
                      },
                      attrs: { type: "text", name: "" },
                      domProps: { value: _vm.displayName },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.displayName = $event.target.value
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "ftp-input-line" },
                  [
                    _c("font", { staticClass: "cloud-cont-name" }, [
                      _vm._v(
                        _vm._s(_vm.$t("language.popup.addCloudPopup.server"))
                      )
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.port,
                          expression: "port"
                        }
                      ],
                      ref: "portInput",
                      staticClass: "ftp-cont-right-one",
                      class: [_vm.portNull ? "error-border" : ""],
                      attrs: { type: "text" },
                      domProps: { value: _vm.port },
                      on: {
                        blur: _vm.portBlur,
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.port = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.httpName,
                          expression: "httpName"
                        }
                      ],
                      staticClass: "ftp-cont-input",
                      style: {
                        width: this.$i18n.locale == "italian" ? "260Px" : ""
                      },
                      attrs: { type: "text" },
                      domProps: { value: _vm.httpName },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.httpName = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "question-mark",
                        attrs: { id: "questionMark" }
                      },
                      [
                        _c("div", {
                          staticClass: "icon-util question addftp-icon-position"
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "ftp-explanation" },
                          [
                            _c("font", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t(
                                    "language.popup.addCloudPopup.explanation"
                                  )
                                )
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "ftp-input-line" },
                  [
                    _c("font", { staticClass: "cloud-cont-name" }, [
                      _vm._v(
                        _vm._s(_vm.$t("language.popup.addCloudPopup.userName"))
                      )
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.email,
                          expression: "email"
                        }
                      ],
                      staticClass: "ftp-cont-three",
                      style: {
                        width: this.$i18n.locale == "italian" ? "450Px" : ""
                      },
                      attrs: { type: "text" },
                      domProps: { value: _vm.email },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.email = $event.target.value
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "ftp-input-line" },
                  [
                    _c("font", { staticClass: "cloud-cont-name" }, [
                      _vm._v(
                        _vm._s(_vm.$t("language.popup.addCloudPopup.passWord"))
                      )
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.password,
                          expression: "password"
                        }
                      ],
                      staticClass: "ftp-cont-three",
                      style: {
                        width: this.$i18n.locale == "italian" ? "450Px" : ""
                      },
                      attrs: { type: "password" },
                      domProps: { value: _vm.password },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.password = $event.target.value
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "advanced" }, [
                  _c(
                    "div",
                    { staticClass: "advanced-menu" },
                    [
                      _c(
                        "font",
                        {
                          staticClass: "advanced-text",
                          attrs: { id: "advancedText" },
                          on: {
                            click: function($event) {
                              return _vm.advancedDivShow()
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("language.popup.addCloudPopup.advanced")
                            ) + "\r\n                            "
                          ),
                          _c("div", {
                            staticClass: "icon-util folding-panel slide",
                            class: { "folding-panel-up": _vm.advancedShow },
                            attrs: { id: "iconUtil" }
                          })
                        ]
                      )
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c("transition", { attrs: { name: "ftp-slide" } }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.advancedShow,
                        expression: "advancedShow"
                      }
                    ],
                    staticClass: "add-ftp-buttom"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "advanced-item" },
                      [
                        _c("font", { staticClass: "advanced-item-name" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("language.popup.addCloudPopup.commFTP")
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticStyle: { float: "left" },
                            style: {
                              marginLeft:
                                this.$i18n.locale == "italian" ? "30Px" : ""
                            }
                          },
                          [
                            _c("cloud-select", {
                              attrs: {
                                selectOption: _vm.commonFTP,
                                placeholder: _vm.selectFTPValue
                              },
                              on: { changeOption: _vm.onChangeOptionTwo }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "advanced-item" },
                      [
                        _c("font", { staticClass: "advanced-item-name" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("language.popup.addCloudPopup.transMode")
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticStyle: { float: "left" },
                            style: {
                              marginLeft:
                                this.$i18n.locale == "italian" ? "30Px" : ""
                            }
                          },
                          [
                            _c("cloud-select", {
                              attrs: {
                                selectOption: _vm.transferMode,
                                placeholder: _vm.selectModeValue
                              },
                              on: { changeOption: _vm.changeTransferMode }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "advanced-item" },
                      [
                        _c("font", { staticClass: "advanced-item-name" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("language.popup.addCloudPopup.encoding")
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticStyle: { float: "left" },
                            style: {
                              marginLeft:
                                this.$i18n.locale == "italian" ? "30Px" : ""
                            }
                          },
                          [
                            _c("cloud-select", {
                              attrs: {
                                selectOption: _vm.enCoding,
                                placeholder: _vm.selectCodValue
                              },
                              on: { changeOption: _vm.onChangeCharSet }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "ftp-input-line" },
                      [
                        _c("font", { staticClass: "cloud-cont-name" }, [
                          _vm._v(
                            _vm._s(_vm.$t("language.popup.addCloudPopup.path"))
                          )
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.path,
                              expression: "path"
                            }
                          ],
                          staticClass: "ftp-cont-three",
                          class:
                            _vm.advancedShow && !_vm.SftpShow
                              ? "path-input"
                              : "",
                          style: {
                            width: this.$i18n.locale == "italian" ? "450Px" : ""
                          },
                          attrs: { type: "text" },
                          domProps: { value: _vm.path },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.path = $event.target.value
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("transition", { attrs: { name: "ftp-slide" } }, [
                _vm.SftpShow
                  ? _c("div", { staticClass: "add-ftp-text" }, [
                      _c("div", { staticClass: "cloud-cont-name" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("language.popup.addCloudPopup.privateKey")
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.optional,
                            expression: "optional"
                          }
                        ],
                        attrs: { rows: "8" },
                        domProps: { value: _vm.optional },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.optional = $event.target.value
                          }
                        }
                      })
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticStyle: { float: "right" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.addFtpSubmit()
                    }
                  }
                },
                [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.connect && _vm.$i18n.locale != "deutsch",
                          expression: "!connect && $i18n.locale!='deutsch'"
                        }
                      ]
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("language.common.add")) +
                          "  " +
                          _vm._s(_vm.cloudName) +
                          " " +
                          _vm._s(_vm.$t("language.common.account"))
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.connect && _vm.$i18n.locale == "deutsch",
                          expression: "!connect && $i18n.locale=='deutsch'"
                        }
                      ]
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.cloudName) +
                          " " +
                          _vm._s(_vm.$t("language.common.account")) +
                          "  " +
                          _vm._s(_vm.$t("language.common.add"))
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.connect,
                          expression: "connect"
                        }
                      ]
                    },
                    [
                      _vm._v(_vm._s(_vm.$t("language.common.connecting"))),
                      _c("span", { staticClass: "cloudDotting" })
                    ]
                  )
                ]
              )
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-757bcca4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-757bcca4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/add_cloud_popups/add_ftp_popup.vue
// module id = null
// module chunks = 